interface ComputerGuyAndAntennaSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerGuyAndAntennaSVG = ({
  color,
  style,
}: ComputerGuyAndAntennaSVGProps) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <svg
      style={{ marginRight: '12px', ...style }}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="51"
      viewBox="0 0 18 51"
      fill="none"
    >
      <g clipPath="url(#clip0_465_6029)">
        <path
          d="M13.1211 0.569336C13.6394 2.01254 13.9443 3.73016 13.9443 5.5799C13.9443 7.42964 13.6394 9.13709 13.1211 10.5905"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5864 3.53711C11.7999 4.12659 11.9218 4.8177 11.9218 5.56979C11.9218 6.32188 11.7999 7.02316 11.5864 7.60247"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.74609 0.569336C4.22775 2.01254 3.92285 3.73016 3.92285 5.5799C3.92285 7.42964 4.22775 9.13709 4.74609 10.5905"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.28071 3.53711C6.06727 4.12659 5.94531 4.8177 5.94531 5.56979C5.94531 6.32188 6.06727 7.02316 6.28071 7.60247"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6619 45.1966L11.3425 20.3877H8.65933H6.52502L2.20557 45.1966"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1758 42.7982L6.58594 32.6348L8.93369 28.417"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.70166 42.7982L11.2814 32.6348L8.93362 28.417"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.44339 45.1968H16.4344C16.9121 45.1968 17.3085 45.898 17.3085 46.7619V48.8759C17.3085 49.7398 16.9223 50.4411 16.4344 50.4411H1.44339C0.965709 50.4411 0.569336 49.7398 0.569336 48.8759V46.7619C0.569336 45.898 0.955546 45.1968 1.44339 45.1968Z"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.90723 20.3879V16.6172C7.90723 16.0379 8.17148 15.5806 8.48654 15.5806H9.37076C9.68582 15.5806 9.95007 16.0481 9.95007 16.6172V20.3879"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.93359 15.5703V7.78516"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1838 4.60383C10.1838 5.30511 9.62481 5.88442 8.93369 5.88442C8.24258 5.88442 7.68359 5.31527 7.68359 4.60383C7.68359 3.89239 8.24258 3.32324 8.93369 3.32324C9.62481 3.32324 10.1838 3.89239 10.1838 4.60383Z"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_465_6029">
          <rect width="17.8673" height="51" fill={color} />
        </clipPath>
      </defs>
    </svg>
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="47"
      viewBox="0 0 48 47"
      fill="none"
    >
      <g clipPath="url(#clip0_465_6043)">
        <path
          d="M25.5171 18.6201L30.6571 23.0601V28.4201"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6971 18.4902L9.55713 23.0602V28.4202"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.397 11.5501C26.397 15.6501 23.607 18.9801 20.167 18.9801C16.727 18.9801 13.937 15.6501 13.937 11.5501C13.937 7.45012 16.727 4.12012 20.167 4.12012C23.607 4.12012 26.397 7.45012 26.397 11.5501Z"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.3872 42.3999L37.7972 30.9399C38.1672 29.6799 37.2272 28.4199 35.9172 28.4199H4.29719C2.98719 28.4199 2.04719 29.6799 2.41719 30.9399L5.82719 42.3999H20.1672"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.41698 40L1.59698 43.42C1.06698 44.42 1.78698 45.62 2.91698 45.62H37.287C38.417 45.62 39.137 44.42 38.607 43.42L36.787 40"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.2572 12.7101L31.4072 15.4701V3.51006C31.4072 1.88006 32.7272 0.560059 34.3572 0.560059H44.4272C46.0572 0.560059 47.3772 1.88006 47.3772 3.51006V9.77006C47.3772 11.4001 46.0572 12.7201 44.4272 12.7201H34.2572V12.7101Z"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.2871 4.95996H42.7071"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.2871 8.02002H42.7071"
          stroke={color}
          strokeWidth="1.12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_465_6043">
          <rect
            width="47.08"
            height="46.18"
            fill={color}
            transform="translate(0.867188)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default ComputerGuyAndAntennaSVG;
